import api from '../../../lib/api';
import type {
  AudiencePreview,
  Campaign,
  CampaignActiveCount,
  CreateCampaignInput,
  PaginatedCampaignLeads,
  PaginatedCampaigns,
  QueryCampaignsParams,
  UpdateCampaignInput,
} from '../types';

export const campaignsApi = {
  list: (params: QueryCampaignsParams) =>
    api.get<PaginatedCampaigns>('/campaigns', { params }).then((res) => res.data),

  getOne: (id: string, organizationId: string) =>
    api.get<Campaign>(`/campaigns/${id}`, { params: { organizationId } }).then((res) => res.data),

  create: (input: CreateCampaignInput) =>
    api.post<Campaign>('/campaigns', input).then((res) => res.data),

  update: (id: string, organizationId: string, input: UpdateCampaignInput) =>
    api
      .patch<Campaign>(`/campaigns/${id}`, input, { params: { organizationId } })
      .then((res) => res.data),

  remove: (id: string, organizationId: string) =>
    api.delete(`/campaigns/${id}`, { params: { organizationId } }).then((res) => res.data),

  activate: (id: string, organizationId: string) =>
    api
      .post<Campaign>(`/campaigns/${id}/activate`, undefined, { params: { organizationId } })
      .then((res) => res.data),

  complete: (id: string, organizationId: string) =>
    api
      .post<Campaign>(`/campaigns/${id}/complete`, undefined, { params: { organizationId } })
      .then((res) => res.data),

  addLeads: (id: string, organizationId: string, leadIds: string[]) =>
    api.post(`/campaigns/${id}/leads`, { organizationId, leadIds }).then((res) => res.data),

  removeLeads: (id: string, organizationId: string, leadIds: string[]) =>
    api
      .delete(`/campaigns/${id}/leads`, { data: { organizationId, leadIds } })
      .then((res) => res.data),

  setSegmentFilters: (id: string, organizationId: string, filters: Record<string, unknown>) =>
    api.put(`/campaigns/${id}/segment`, { organizationId, filters }).then((res) => res.data),

  listCampaignLeads: (
    id: string,
    params: { organizationId: string; limit?: number; offset?: number },
  ) =>
    api.get<PaginatedCampaignLeads>(`/campaigns/${id}/leads`, { params }).then((res) => res.data),

  previewAudience: (id: string, organizationId: string) =>
    api
      .get<AudiencePreview>(`/campaigns/${id}/preview-audience`, { params: { organizationId } })
      .then((res) => res.data),

  getActiveCount: (organizationId: string) =>
    api
      .get<CampaignActiveCount>('/campaigns/stats/active-count', { params: { organizationId } })
      .then((res) => res.data),
};
